import {config} from './hapi.config';

// https://nuxt.com/docs/api/configuration/nuxt-config
export default defineAppConfig({
	host: config[config.default].host,
	lang: 'si',
	baseCompatibility: '1.29.0',
	cache: {
		debug: false,
		enabled: config[config.default].apiCache,
		refresh: {
			currency: 1440, // 24 hours
			endpoints: 1440,
			info: 1440,
			labels: 10,
			menus: 30,
			redirects: 60,
			rotators: 10,
			routes: 5,
			token: 1440,
			newsletter: 1440,
			gdprTemplate: 1440,
			thumbs: 180,
			cmsPages: 60,
			catalogCategories: 5,
			catalogLists: 5,
			catalogManufacturers: 30,
			catalogProducts: 5,
			catalogProduct: 5,
			catalogSellers: 5,
			faqCategories: 60,
			faqQuestions: 60,
			faqQuestion: 60,
			publishCategories: 60,
			publishPost: 30,
			publishPosts: 30,
			locationPoints: 60,
			staticContent: 60,
		},
	},
	layouts: [
		{
			template: [
				'WebshopLogin',
				'WebshopCustomer',
				'WebshopShipping',
				'WebshopReviewOrder',
				'WebshopThankYou',
				'WebshopCancelOrder',
				'WebshopFailedOrder',
				'WebshopFailedPayment',
				'WebshopPaymentCreate',
				'WebshopPaymentNew',
				'WebshopPaymentOnHold',
				'WebshopPaymentFormAutosubmit',
				'WebshopViewAdditionalpayment',
				'WebshopAdditionalpaymentsThankYou',
			],
			layout: 'checkout',
		},
		{
			template: ['AuthLogin', 'AuthLogout'],
			layout: 'spinner',
		},
	],
	fetchApi: {
		put: {
			appendLang: false,
		},
	},
	catalog: {
		productsResponseFields: [
			'active_shipping_options_count',
			'attributes_special',
			'availability_info',
			'available_qty',
			'badges',
			'badges_special_1',
			'badges_special_2',
			'basic_price_custom',
			'category_title',
			'category_url_without_domain',
			'code',
			'date_available',
			'discount_percent_custom',
			'extra_price_cart_dynamicprice',
			'extra_price_dynamicprice',
			'extra_price_mode_dynamicprice',
			'feedback_comment_widget',
			'feedback_rate_widget',
			'id',
			'installments_calculation',
			'is_available',
			'is_rate',
			'last_piece_sale',
			'loyalty_price_custom',
			'main_image_description',
			'main_image_title',
			'main_image_upload_path',
			'price_custom',
			'element_state_code',
			'quantity',
			'selected_price',
			'seller_id',
			'seller_title',
			'seller_url_product_page_without_domain',
			'seller_url_without_domain',
			'shipping_date',
			'shipping_options',
			'shopping_cart_code',
			'status',
			'title',
			'type',
			'url_without_domain',
			'warehouses_single_pickup_display',
			'xxx',
		],
		fetch: {
			//check_lists: config.default === 'prod' || config.default === 'beta' ? 'webcatalog_157271,webcatalog_157270,webcatalog_201949,webcatalog_1219026' : 'webcatalog_157271,webcatalog_157270,webcatalog_201949,webcatalog_2225499',
			check_lists: 'webcatalog_cs-fm,webcatalog_cs-lb,webcatalog_cs-lt,webcatalog_3d-ar',
			appconfig: 'product_pim_min_chars',
		},
		hooks: {
			mapProduct: product => {
				if (product?.type == 'configurable' && product?.initial_offer) {
					return product.initial_offer;
				}
				return product;
			},
		},
	},
	keycloak: true,
	auth: {
		loggedOutRedirect: 'home',
	},
	structuredData: {
		enabled: true,
		basic: {
			name: 'Big Bang',
			organizationName: 'Big Bang',
			logo: 'https://www.bigbang.si/media/images/logo-mail.png', // FIXME INTEG privremeni logo
			phone: '013626000',
			email: 'info@bigbang.si',
			socialNetworkUrls: '"https://www.facebook.com/BigBangSlovenija?ref=hl","https://www.instagram.com/bigbangslo/","https://www.youtube.com/user/BigBangSlovenija","https://www.linkedin.com/company/big-bang-slovenija"',
		},
	},
	thumbPresets: {
		headerCategories: {
			imageFields: ['main_image_upload_path', 'main_image_2_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 75,
						height: 75,
						crop: false,
					},
				},
			],
		},
		headerPromo: {
			imageFields: ['image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 980,
						height: 980,
						crop: false,
					},
				},
			],
		},
		headerBrands: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 170,
						height: 80,
						crop: false,
					},
				},
			],
		},
		headerServices: {
			imageFields: ['main_image_3_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 980,
						height: 980,
						crop: false,
					},
				},
			],
		},
		heroRotator: {
			imageFields: ['image_upload_path', 'image_4_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1480,
						height: 540,
						crop: true,
					},
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 760,
						height: 397,
						crop: true,
					},
				},
			],
		},
		promoCards: {
			imageFields: ['image_upload_path', 'image_2_upload_path'],
			thumbs: [
				{
					alias: 'thumb_big',
					config: {
						width: 730,
						height: 540,
						crop: false,
					},
				},
				{
					alias: 'thumb_medium',
					config: {
						width: 730,
						height: 260,
						crop: false,
					},
				},
				{
					alias: 'thumb_icon',
					config: {
						width: 140,
						height: 70,
						crop: false,
					},
				},
			],
		},
		homepageCategories: {
			imageFields: ['image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 75,
						height: 75,
						crop: true,
					},
				},
			],
		},
		promoFeaturedRotator: {
			imageFields: ['image_upload_path', 'image_2_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 355,
						height: 180,
						crop: true,
					},
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 390,
						height: 270,
						crop: true,
					},
				},
			],
		},
		homepageSis: {
			imageFields: ['image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 230,
						height: 100,
						crop: false,
					},
				},
			],
		},
		homepageBrandsItems: {
			imageFields: ['image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 155,
						height: 60,
						crop: false,
					},
				},
			],
		},
		homepageCatalogFeatured: {
			imageFields: ['main_image_3', 'main_image_4', 'main_image_5', 'main_image_6'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 240,
						height: 300,
						crop: true,
					},
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 760,
						height: 760,
						crop: false,
					},
				},
			],
		},
		homepagePromoItems: {
			imageFields: ['main_image_upload_path', 'main_image_2_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 355,
						height: 595,
						crop: true,
					},
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 760,
						height: 760,
						crop: false,
					},
				},
			],
		},
		staticcontentCatalogPromo: {
			imageFields: ['image', 'image2'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 240,
						height: 300,
						crop: true,
					},
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 760,
						height: 760,
						crop: false,
					},
				},
			],
		},
		publishEntry: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 475,
						height: 230,
						crop: true,
					},
				},
			],
		},
		publishBig: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 800,
						height: 385,
						crop: true,
					},
				},
			],
		},
		publishSmall: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 160,
						height: 151,
						crop: true,
					},
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 475,
						height: 230,
						crop: true,
					},
				},
			],
		},
		publishMenu: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 170,
						height: 130,
						crop: true,
					},
				},
			],
		},
		publishDetail: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1480,
						height: 540,
						crop: true,
					},
				},
			],
		},
		publishDetailExtra: {
			imageFields: ['url'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 920,
						height: 920,
						crop: false,
					},
				},
			],
		},
		promotionEntry: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 760,
						height: 398,
						crop: true,
					},
				},
			],
		},
		promotionFeaturedEntry: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 730,
						height: 382,
						crop: true,
					},
				},
			],
		},
		publishPromotionDetail: {
			imageFields: ['url'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1480,
						height: 540,
						crop: true,
					},
				},
			],
		},
		servicesCategory: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 480,
						height: 220,
						crop: true,
					},
				},
			],
		},
		faqCategories: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 480,
						height: 220,
						crop: true,
					},
				},
			],
		},
		catalogCategories: {
			imageFields: ['main_image_2_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 140,
						height: 140,
						crop: false,
					},
				},
			],
		},
		promoRotator: {
			imageFields: ['image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 480,
						height: 2000,
						crop: false,
					},
				},
				{
					alias: 'thumb_big',
					config: {
						width: 730,
						height: 2000,
						crop: false,
					},
				},
			],
		},
		manufacturers: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 170,
						height: 80,
						crop: false,
					},
				},
			],
		},
		addToCartModal: {
			imageFields: ['image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 70,
						height: 70,
						crop: false,
					},
				},
			],
		},
		cartPackage: {
			imageFields: ['image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 64,
						height: 64,
						crop: false,
					},
				},
			],
		},
		catalogEntry: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 240,
						height: 240,
						crop: false,
					},
				},
			],
		},
		catalogCategory: {
			imageFields: ['element_image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 140,
						height: 140,
						crop: false,
					},
				},
			],
		},
		promoCatalog: {
			imageFields: ['image', 'image_2'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1480,
						height: 540,
						crop: true,
					},
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 724,
						height: 380,
						crop: true,
					},
				},
				{
					alias: 'medium_thumb',
					config: {
						width: 724,
						height: 379,
						crop: true,
					},
				},
				{
					alias: 'small_thumb',
					config: {
						width: 346,
						height: 181,
						crop: true,
					},
				},
			],
		},
		promoCatalogSpecial: {
			imageFields: ['image', 'image_2'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1480,
						height: 160,
						crop: true,
					},
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 760,
						height: 260,
						crop: true,
					},
				},
			],
		},
		promoCategory: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 888,
						height: 324,
						crop: false,
					},
				},
			],
		},
		location: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 640,
						height: 320,
						crop: true,
					},
				},
				{
					alias: 'thumb_map',
					config: {
						width: 300,
						height: 140,
						crop: true,
					},
				},
			],
		},
		faqPromo: {
			imageFields: ['image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 730,
						height: 220,
						crop: true,
					},
				},
			],
		},
		seller: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 146,
						height: 146,
						crop: false,
					},
				},
			],
		},
		catalogDetail: {
			imageFields: ['all_images.file'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 640,
						height: 640,
						crop: false,
					},
				},
				{
					alias: 'thumb_small',
					config: {
						width: 110,
						height: 110,
						crop: false,
					},
				},
				{
					alias: 'thumb_zoom',
					config: {
						width: 1000,
						height: 1000,
						crop: false,
					},
				},
			],
		},
		catalogDetailExtra: {
			imageFields: ['main_image_upload_path', 'energy_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 70,
						height: 70,
						crop: false,
					},
				},
				{
					alias: 'thumb_energy',
					config: {
						width: 300,
						height: 585,
						crop: false,
					},
				},
				{
					alias: 'thumb_energy_gallery',
					config: {
						width: 1500,
						height: 1500,
						crop: false,
					},
				},
			],
		},
		catalogGallery: {
			imageFields: ['url'],
			thumbs: [
				{
					alias: 'thumb_gallery',
					config: {
						width: 1500,
						height: 1500,
						crop: false,
					},
				},
				{
					alias: 'thumb_gallery_small',
					config: {
						width: 133,
						height: 133,
						crop: false,
					},
				},
			],
		},
		order: {
			imageFields: ['main_image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 140,
						height: 140,
						crop: false,
					},
				},
			],
		},
		cart: {
			imageFields: ['image', 'main_image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 120,
						height: 120,
						crop: false,
					},
				},
			],
		},
		searchForm: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 70,
						height: 70,
						crop: false,
					},
				},
			],
		},
		comment: {
			imageFields: ['main_image_upload_path'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 100,
						height: 100,
						crop: false,
					},
				},
			],
		},
		landingImage: {
			imageFields: ['image', 'image2'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1920,
						height: 800,
						crop: false,
					},
				},
				{
					alias: 'thumb_icon',
					config: {
						width: 150,
						height: 60,
						crop: false,
					},
				},
			],
		},
		landingImagePromo: {
			imageFields: ['image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 740,
						height: 400,
						crop: true,
					},
				},
			],
		},
		landingPromoBig: {
			imageFields: ['image', 'image2'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 1480,
						height: 1480,
						crop: false,
					},
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 760,
						height: 760,
						crop: false,
					},
				},
			],
		},
		landingPromoMedium: {
			imageFields: ['image', 'image2'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 760,
						height: 760,
						crop: false,
					},
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 760,
						height: 760,
						crop: false,
					},
				},
			],
		},
		landingPromoSmall: {
			imageFields: ['image', 'image2'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 480,
						crop: false,
					},
				},
				{
					alias: 'thumb_mobile',
					config: {
						width: 760,
						height: 760,
						crop: false,
					},
				},
			],
		},
		landingImageProduct: {
			imageFields: ['image'],
			thumbs: [
				{
					alias: 'thumb',
					config: {
						width: 480,
						height: 480,
						crop: false,
					},
				},
			],
		},
	},
});
